import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Guard that only accepts if representative was recently deleted
 */
export class RepresentativeDeletedGuard implements CanActivate {
  /**
   * @constructor
   */
  constructor(
    private readonly authenticatedUserService: AuthenticatedUserService,
    private readonly navigationService: NavigationService
  ) {}

  /**
   *  @return {boolean}
   */
  canActivate(): boolean {
    if (!this.authenticatedUserService.representativeDeleted) {
      this.navigationService.back();
      return false;
    }
    return true;
  }
}
